import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { exchangeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/acceso", { replace: true });
      return;
    }
    exchangeGoogle(decodeURIComponent(match[1]))
      .then(() => {
        toast.success("Sesión iniciada con Google.");
        navigate("/panel", { replace: true });
      })
      .catch(() => {
        toast.error("No se pudo iniciar sesión con Google.");
        navigate("/acceso", { replace: true });
      });
  }, []); // eslint-disable-line

  return (
    <div className="relative z-10 flex min-h-screen flex-col items-center justify-center gap-4">
      <Loader2 className="h-7 w-7 animate-spin text-cyber-cyan" />
      <p className="font-mono-tech text-xs uppercase tracking-[0.2em] text-white/60">
        Verificando identidad...
      </p>
    </div>
  );
}
